import { useState } from "react";
import { Button } from "@/components/ui/button";

const PAGE = 10;

export function usePaged(items, step = PAGE) {
  const [limit, setLimit] = useState(step);
  const list = items || [];
  return {
    visible: list.slice(0, limit),
    hasMore: list.length > limit,
    remaining: Math.max(0, list.length - limit),
    showMore: () => setLimit((l) => l + step),
    total: list.length,
  };
}

export const ShowMore = ({ paged, testid, step = PAGE }) =>
  paged.hasMore ? (
    <div className="flex justify-center p-4">
      <Button
        variant="outline"
        size="sm"
        data-testid={testid}
        onClick={paged.showMore}
        className="min-h-[44px]"
      >
        Show {Math.min(step, paged.remaining)} more · {paged.remaining} left
      </Button>
    </div>
  ) : null;
